var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.show ? 'show' : '',attrs:{"id":"login-overlay"}},[_c('div',{staticClass:"overlay--box"},[_c('span',{staticClass:"overlay--close",on:{"click":_vm.closeLogin}}),_c('Menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }